import { Inject, Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class SmartTableService {
  public onRemove: EventEmitter<any> = new EventEmitter();
  public onEdit: EventEmitter<any> = new EventEmitter();
  public onToggleSortingAndFiltering: EventEmitter<any> = new EventEmitter();
  public onToggleAddNewRecordButton: EventEmitter<any> = new EventEmitter();
  public onDisableRowUpdateSuccess: EventEmitter<any> = new EventEmitter();
  public onDisableRowUpdateFailure: EventEmitter<any> = new EventEmitter();
  public onDisableActionsOnRows: EventEmitter<any> = new EventEmitter();
  public onToggleCheckBox: EventEmitter<any> = new EventEmitter();
  public onFocusRow: EventEmitter<any> = new EventEmitter();
  public observable = new Subject<any>();
  public editObservable = new ReplaySubject<any>(1);
  constructor(
    private logger: NGXLogger
  ) {
    this.logger.log('Hello SmartTable Service');
  }
  public remove(element: any): Observable<any> {
    this.onRemove.emit(element);
    return this.observable.asObservable();
  }

  public isEdit(): Observable<boolean> {
     this.onEdit.emit();
     return this.editObservable.asObservable();
  }

  public toggleSortingAndFiltering(toggle: boolean) {
    this.onToggleSortingAndFiltering.emit(toggle);
  }
  public toggleAddNewRecordButton(toggle: boolean) {
    this.onToggleAddNewRecordButton.emit(toggle);
  }
  public disableRowUpdateSuccess() {
    this.onDisableRowUpdateSuccess.emit();
  }
  public disableRowUpdateFailure() {
    this.onDisableRowUpdateFailure.emit();
  }
  public disableActionsOnRows(records: any[]) {
    this.onDisableActionsOnRows.emit(records);
  }
  public toggleCheckBox() {
    this.onToggleCheckBox.emit();
  }
  public focusRow(rowIndex: number, columnName: string) {
    this.onFocusRow.emit({rowIndex, columnName});
  }
}
